import { useEffect, useRef } from "react";
import { drawSparkline } from "../lib/charts";

interface Props {
  values: number[];
  direction?: "good" | "warn" | "bad" | "neutral";
  className?: string;
  viewBox?: string;
  height?: number;
}

export default function Sparkline({ values, direction, className = "kpi-spark", viewBox = "0 0 200 36", height }: Props) {
  const ref = useRef<SVGSVGElement>(null);
  useEffect(() => {
    if (ref.current && values.length) {
      drawSparkline(ref.current as unknown as SVGElement, values, direction);
    }
    const obs = new MutationObserver(() => {
      if (ref.current && values.length) drawSparkline(ref.current as unknown as SVGElement, values, direction);
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, [values, direction]);
  return <svg ref={ref} className={className} viewBox={viewBox} preserveAspectRatio="none" style={height ? { height } : undefined} />;
}
